import React from 'react';
import { useIntl } from 'react-intl';
import { FaCheck } from 'react-icons/fa';
import { activeClass } from 'helpers/activeClass';
import messages from '../messages';

const Linking = ({ params, setParams }) => {
  const { formatMessage } = useIntl();

  const toggle = name => {
    if (params[name]) {
      const { [name]: tmp, ...rest } = params;
      setParams(rest);
    } else {
      setParams({ ...params, [name]: 1 });
    }
  };

  return (
    <div className="group">
      <h3>{formatMessage(messages.connected_products)}</h3>
      <div className="form_checkbox" onClick={() => toggle('connected')}>
        <div className={activeClass('box', params.connected === 1)}>
          <span>
            <FaCheck />
          </span>
        </div>
        <label>{formatMessage(messages.connected)}</label>
      </div>
      <div className="form_checkbox" onClick={() => toggle('disconnected')}>
        <div className={activeClass('box', params.disconnected === 1)}>
          <span>
            <FaCheck />
          </span>
        </div>
        <label>{formatMessage(messages.disconnected)}</label>
      </div>
    </div>
  );
};

export default Linking;
